import React, { createContext, useContext, useState } from 'react';

const PlayerContext = createContext(null);
export const usePlayer = () => useContext(PlayerContext);

export const PlayerProvider = ({ children }) => {
  const [video, setVideo] = useState(null); // { id, title }
  const [visible, setVisible] = useState(false);
  const play = (v) => { setVideo(v); setVisible(true); };
  const close = () => { setVisible(false); setVideo(null); };
  return (
    <PlayerContext.Provider value={{ video, visible, play, close }}>
      {children}
    </PlayerContext.Provider>
  );
};
